import { z } from "zod";

import { PrototypeExpr } from "../prototype/expr.ts";
import { ElementInteractions } from "../prototype/interactions.ts";

// A templated text child: `text` keeps the canonical `${...}` string (canvas
// fallback for unknown refs), `binding` the parser-compiled expr.
export const SreText = z
  .object({
    text: z.string(),
    binding: PrototypeExpr.optional(),
  })
  .strict();
export type SreText = z.infer<typeof SreText>;

const BaseSre = z.object({
  type: z.string(), // HtmlElementName | ShadCnComponentName | LucideIconName
  props: z.record(z.string(), z.unknown()).optional(),
  interactions: ElementInteractions.optional(),
});
type BaseSre = z.infer<typeof BaseSre>;

export const Sre: z.ZodType<Sre> = BaseSre.extend({
  children: z
    .array(z.union([z.string(), SreText, z.lazy(() => Sre)]))
    .optional(),
}).strict();
export type Sre = z.infer<typeof BaseSre> & {
  children?: (Sre | SreText | string)[];
};
